module.exports = __webpack_public_path__ + "img/Headset.dc2bc2ef.svg";